const interfaceTranslations = {
  selectedCountryAriaLabel: "Valgt land",
  noCountrySelected: "Ingen land er valgt",
  countryListAriaLabel: "Liste over land",
  searchPlaceholder: "Leting",
  zeroSearchResults: "Ingen resultater funnet",
  oneSearchResult: "1 resultat funnet",
  multipleSearchResults: "${count} resultater funnet",
  // additional countries (not supported by country-list library)
  ac: "Ascension Island",
  xk: "Kosovo"
};
export default interfaceTranslations;